export class DateTimeRegex {
  /**Regex esxpression testing if date-string follows either pattern "dd-mm-yyyy" OR "dd/mm/yyyy" */
  public static DATE_ddmmyyyy_GENERAL_REGEXEXPR: string =
    "^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]d{4}$";

  /**Regex esxpression testing if date-string follows pattern "dd/mm/yyyy" */
  public static DATE_ddmmyyyy_ONLY_SLASH_REGEXEXPR: string =
    "^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/-]d{4}$";

  /**Regex esxpression testing if date-string follows pattern "dd-mm-yyyy" */
  public static DATE_ddmmyyyy_ONLY_SCORE_REGEXEXPR: string =
    "^[0-9]{2}[-]{1}[0-9]{2}[-]{1}[0-9]{4}$";

  /**Regex esxpression testing if date-string follows pattern "yyyy-mm-dd" */
  public static DATE_yyyymmdd_ONLY_SCORE_REGEXEXPR: string =
    "^[0-9]{4}[-]{1}[0-9]{2}[-]{1}[0-9]{2}$";

  /**Regex esxpression testing if date-string follows pattern "d-mm-yyyy" */
  public static DATE_dmmyyyy_ONLY_SCORE_SINGLE_DAY_REGEXEXPR: string =
    "^[1-9]{1}[-]{1}[0-9]{2}[-]{1}[0-9]{4}$";

  /**Regex esxpression testing if date-string follows pattern "dd-m-yyyy" */
  public static DATE_ddmyyyy_ONLY_SCORE_SINGLE_MONTH_REGEXEXPR: string =
    "^[0-9]{2}[-]{1}[1-9]{1}[-]{1}[0-9]{4}$";

  /**Regex esxpression testing if date-string follows pattern "d-m-yyyy" */
  public static DATE_dmyyyy_ONLY_SCORE_SINGLE_DAY_MONTH_REGEXEXPR: string =
    "^[1-9]{1}[-]{1}[1-9]{1}[-]{1}[0-9]{4}$";

  /**Regex esxpression testing if date-string follows pattern "ddmmyyyy", with NO separators */
  public static DATE_ddmmyyyy_NO_SEPARATION_REGEXEXPR: string =
    "^[0-9]{2}[0-9]{2}[0-9]{4}$";

  /**Regex esxpression testing if date-string follows pattern "ddmmyy", with NO separators */
  public static DATE_ddmmyy_NO_SEPARATION_REGEXEXPR: string =
    "^[0-9]{2}[0-9]{2}[0-9]{2}$";

  /**Regex esxpression testing if date-string follows pattern "HH:mm */
  public static TIME_HHMM_COLON_REGEXEXPR: string = "^[0-9]{2}[:]{1}[0-9]{2}$";

  /**Regex esxpression testing if date-string follows pattern "H:mm (24-hour based, BUT without initial ZERO for hour) */
  public static TIME_HMM_COLON_REGEXEXPR: string = "^[0-9]{1}[:]{1}[0-9]{2}$";

  /**Regex esxpression testing if date-string follows pattern "HH:m (24-hour based, BUT without initial ZERO for minutes) */
  public static TIME_HHM_COLON_REGEXEXPR: string = "^[0-9]{2}[:]{1}[0-9]{1}$";

  /**Regex esxpression testing if date-string follows pattern "H:m (24-hour based, BUT without initial ZERO for BOTH hours AND minutes) */
  public static TIME_HM_COLON_REGEXEXPR: string = "^[0-9]{1}[:]{1}[0-9]{1}$";

  /**Regex esxpression testing if date-string follows pattern "HHmm (24-hour based, BUT without separating colon) */
  public static TIME_HHMM_NO_SEPARATION_REGEXEXPR: string =
    "^[0-9]{2}[0-9]{2}$";
}
